import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from 'src/app/shared/_service/session.service';

@Component({
	selector: 'app-detail-accessories',
	templateUrl: './detail-accessories.component.html',
})
export class DetailAccessoriesComponent implements OnInit {
	constructor(
		private route: ActivatedRoute,
		private session: SessionService,
		private router: Router,
	) {}

	accessorio: any;

	descrizione = '';

	ngOnInit() {
		this.route.params.subscribe((params) => {
			if (params.codiceCommerciale) {
				const codiceCommerciale = decodeURIComponent(params.codiceCommerciale);
				this.session.getAccessori().subscribe((accessorio) => {
					this.accessorio = accessorio.find((p) => p.prodottiCommerciali.find((pc) => pc.codiceCommerciale === codiceCommerciale));
					if (!this.accessorio) {
						console.log('Prodotto Commerciale ' + codiceCommerciale + ' non trovato.');
						this.router.navigate(['/category']);
					}
					this.accessorio.prodottiCommerciali.forEach((pc) => (pc.quantita = 1));
					this.accessorio.selected = this.accessorio.prodottiCommerciali.find((pc) => pc.codiceCommerciale === codiceCommerciale);
					this.descrizione = (
						this.accessorio.selected.descrizioni.find((d) => d.lingua.codice === 'US') ||
						this.accessorio.descrizioni.find((d) => d.lingua.codice === 'US')
					).valore;
				});
			}
		});
	}

	stepQuantita(mode) {
		if (this.accessorio.selected) {
			if (this.accessorio.selected.quantita > 0 && mode === '-') {
				this.accessorio.selected.quantita--;
			}
			if (
				this.accessorio.selected.quantita < 100 &&
				mode === '+' &&
				!(this.accessorio.selected.statoGiacenza === 'IN_STOCK' && this.accessorio.selected.giacenza <= this.accessorio.selected.quantita)
			) {
				this.accessorio.selected.quantita++;
			}
		}
	}

	buy() {
		this.session
			.setCarrello(this.accessorio.selected.codiceTecnico, this.accessorio.selected.quantita, true)
			.subscribe(() => this.router.navigate(['/cart']));
	}

	getDescrizione(accessorio) {
		return (
			accessorio.selected.descrizioni.find((d) => d.lingua.codice === 'US') || accessorio.descrizioni.find((d) => d.lingua.codice === 'US')
		);
	}
	calcolaGiacenzaMagazzino(prodottoCommerciale) {
		if (prodottoCommerciale?.magazzini && prodottoCommerciale.magazzini.length > 0) {
			return prodottoCommerciale.magazzini.reduce((acc, magazzino) => acc + magazzino.giacenza, 0);
		} else {
			return 0;
		}
	}
}
